const messages = {
    outside_edge:
        'Your current device doesnt support the rendering of this view',
    sms_sent: 'The code was sent to your mobile number',
};

export default messages;
